// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__2RU4d","holder":"loader_holder__3UiI4"};